import { render, staticRenderFns } from "./VentasListaCarritoNoEntregadasItem.vue?vue&type=template&id=22a97135&"
import script from "./VentasListaCarritoNoEntregadasItem.vue?vue&type=script&lang=js&"
export * from "./VentasListaCarritoNoEntregadasItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports